import { render, staticRenderFns } from "./CreateFirstPost.vue?vue&type=template&id=1159aacb&"
import script from "./CreateFirstPost.vue?vue&type=script&lang=js&"
export * from "./CreateFirstPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports